import styled, { css } from "styled-components";

export const ListItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    .texts {
      position: relative;
      left: 2%;
      width: 95%;
    }
  `}
`;
